import React from "react";
export const VendorDetailContext = React.createContext(null);

export const useVendorDetailContext = () => {
  const context = React.useContext(VendorDetailContext);

  if (!context) throw new Error("Vendor Detail Context not provided!");

  return context;
};
